import { render, staticRenderFns } from "./MemberMainInfo.vue?vue&type=template&id=5eae5034"
import script from "./MemberMainInfo.vue?vue&type=script&lang=ts"
export * from "./MemberMainInfo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports